import { z } from 'zod';

export const HardwareModelSchema = z.object({
  id: z.string().uuid(),
  hardware_id: z.string().uuid(),
  model_format: z.string().default('glb'),
  file_name: z.string().nullable(),
  file_size: z.number().default(0),
  scale_factor: z.number().default(1.0),
  origin_offset_x: z.number().default(0),
  origin_offset_y: z.number().default(0),
  origin_offset_z: z.number().default(0),
  rotation_x: z.number().default(0),
  rotation_y: z.number().default(0),
  rotation_z: z.number().default(0),
  bounding_box_w: z.number().default(0),
  bounding_box_h: z.number().default(0),
  bounding_box_d: z.number().default(0),
  notes: z.string().nullable(),
  drill_points_json: z.string().default('{}'),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
});

export const CreateHardwareModelSchema = z.object({
  hardware_id: z.string().uuid(),
  scale_factor: z.number().default(1.0),
  origin_offset_x: z.number().default(0),
  origin_offset_y: z.number().default(0),
  origin_offset_z: z.number().default(0),
  rotation_x: z.number().default(0),
  rotation_y: z.number().default(0),
  rotation_z: z.number().default(0),
  bounding_box_w: z.number().default(0),
  bounding_box_h: z.number().default(0),
  bounding_box_d: z.number().default(0),
  notes: z.string().nullable().optional(),
  drill_points_json: z.string().default('{}'),
});

export const UpdateHardwareModelSchema = CreateHardwareModelSchema.omit({ hardware_id: true }).partial();

export type HardwareModel = z.infer<typeof HardwareModelSchema>;
export type CreateHardwareModel = z.infer<typeof CreateHardwareModelSchema>;
export type UpdateHardwareModel = z.infer<typeof UpdateHardwareModelSchema>;
